module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-upload__inner",
    class: {
      'zk-dragger': _vm.type === 'drag',
        'is-dragOver': _vm.dragOver,
        'is-showCover': _vm.showCover
    },
    on: {
      "click": _vm.handleClick,
      "drop": function($event) {
        $event.preventDefault();
        _vm.onDrop($event)
      },
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragOver = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragOver = false
      }
    }
  }, [(!_vm.showCover) ? _vm._t("default") : _c('cover', {
    attrs: {
      "image": _vm.lastestFile,
      "on-preview": _vm.onPreview,
      "on-remove": _vm.onRemove
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "zk-upload__input",
    attrs: {
      "type": "file",
      "multiple": _vm.multiple,
      "accept": _vm.accept
    },
    on: {
      "change": _vm.handleChange
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-24e6179f"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/upload/src/upload.vue
// module id = 242
// module chunks = 0